/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 17/1/2024
 */

import React from "react";
import {
  Box,
  Button,
  Paper,
  Toolbar,
  Container,
  Typography,
} from "@mui/material";
import { useGetAllMappingsQuery } from "../Store/Services/brPrivService";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { openAddBrPrivModal } from "../Store/Slices/brPrivSlice";
import SearchBar from "../Components/Shared/SearchBar";
import BrPrivTable from "../Components/BrPrivMapping/BrPrivTable";
import BrPrivDialog from "../Components/BrPrivMapping/BrPrivDialog";
import { useEffect } from "react";
import styles from "./Management.module.css";

const BrPrivMapping = () => {
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState([]);

  const { 
    data: brPriv,
    isLoading 
  } = useGetAllMappingsQuery();

  const roles = sessionStorage.getItem("roles");
  

  return (
    roles?.split(",").includes("PRIV_ES_DISPLAY_MAPPINGS") ? (
    <Paper
      elevation={3}
      className={styles.pageContainer}
      style={{
        backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`,
      }}
    >
      <Box>
        <Toolbar className={styles.subNavBar}>
          <Typography className={styles.topic}>
            Privilege Roles Mapping
          </Typography>

          {roles?.split(",").includes("PRIV_ES_ADD_MAPPING") ? (<Button
            onClick={() => dispatch(openAddBrPrivModal())}
            variant="contained"
            color="primary"
            className={styles.buttonItem}
          >
            Add Mapping
          </Button>) : null}
        </Toolbar>
      </Box>
      <Container>
        {!isLoading && (
          <SearchBar
            data={brPriv || []}
            setSearchData={setSearchData}
            text="Search Role"
            search="brPriv"
          />
        )}
      </Container>

      <Container>
        <BrPrivTable data={searchData} />
      </Container>

      <BrPrivDialog />
    </Paper> ) : null
  );
};

export default BrPrivMapping;
